const configData = {
    "BASE_URL": "https://cig-teleassistencia.alentapp.pt:9500",
    "API": "/api",
    "PROJ_VERSION": "1.0.0",

}

export default configData;